var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.isLoading)?_c('a-spin',[_c('a-icon',{staticStyle:{"font-size":"34px"},attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }